<script setup lang="ts">
import { useDisplayNames } from '~/composables/use-display-names';
import { useProjectStore } from '~/stores/project';

const { currentProject } = useProjectStore();
const { getProjectDisplayName } = useDisplayNames();
</script>

<template>
	<span class="truncate px-2.5 text-sm font-semibold">{{ getProjectDisplayName(currentProject) }}</span>
</template>
